<template>
  <v-row>
    <v-col cols="12">
      <v-row dense>
        <v-col cols="3">
          <v-text-field v-model="params.searchKeyword" label="keyword" clearable @keypress.enter="search" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="auto">
          <v-btn color="primary" outlined @click="search">SEARCH</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent, reactive } from 'vue'

export default defineComponent({
  name: 'Search',
  setup(props, { emit }) {
    const params = reactive({
      searchKeyword: ''
    })

    return {
      params,
      search() {
        emit('click:search', params)
      }
    }
  }
})
</script>

<style scoped lang="scss">

</style>
